import { later } from '@ember/runloop';

import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourDoneKey, TourId } from 'webapp/enums/tour';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';
import { HiddenTourStep } from 'webapp/models-custom/tour/designer/option-hidden';

export default class DesignerSelectVisualizationTypeTour extends TourBase {
	static keyForPersistantDone = TourDoneKey.DESIGNER__SELECT_VISUALIZATION;

	get id(): string {
		return TourId.DESIGNER__SELECT_VISUALIZATION;
	}

	override get keyForPersistantDone(): string {
		return DesignerSelectVisualizationTypeTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.RIGHT,
				allowStacked: true,
				attachTo: () => {
					return $(
						'.designer-panel--left .section.section--1.section--open .vis-item.vis--10',
					);
				},
			},
		];
	}

	override start(): void {
		// delay because we wait for panel to open (300ms)
		later(() => {
			super.start();
			this.markDone(); // just one step, once seen, it's done
		}, 500);
	}

	override end(): void {
		super.end();
		this.flowTourDesignerService.resetHiddenTourExplicitlyClosedStatus(
			HiddenTourStep.LEFT_PANEL_HIDDEN,
		);
	}
}
